import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalHeader from '@/desktop/common/modal/header';


const { UI } = Mobi2Go;

const IncompleteProfileModal = ({closeModal}) => {
    const [t] = useTranslation('order.loyalty');

    const className = name => `m2g-customer-loyalty-incomplete-profile-modal${name || ''}`;

    const handleSetUp = () => {
        closeModal();
        UI.trigger('showCustomerDetails');
    }

    return (
        <>
            <div className={className()}>
                <ModalHeader
                    headerText={t('incomplete_profile_title')}
                    onClose={closeModal}
                />
                <div
                    className={className('-body m2g-modal-body')}
                >
                    <div
                        className={className('-text')}
                        dangerouslySetInnerHTML={{
                            __html: t('incomplete_profile_body')
                        }}
                    />
                    <br />
                    <button
                        className={className('-continue-button m2g-button m2g-button--primary')}
                        onClick={closeModal}
                    >
                        {t('incomplete_profile_continue')}
                    </button>
                    <button
                        className={className('-setup-button m2g-button m2g-button--primary')}
                        onClick={handleSetUp}
                    >
                        {t('incomplete_profile_setup')}
                    </button>
                </div>
            </div>
        </>
    );
};

export default IncompleteProfileModal;
